// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__dOK+6","loaderSmall":"Loader_loaderSmall__xpf0S"};